import { Core } from "@faire/design-tokens";
import { browserLevelLanguage } from "@faire/help-center-utils/serialized-data/getLocale";
import { getSettingHelpCenterChatAvailableLocales } from "@faire/help-center-utils/settings/getSettingHelpCenterChatAvailableLocales";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { getSpacing } from "@faire/web--source/slate/spacing";

const getIframeElementFromSelector = (selector: string) => {
  const iframe = document.getElementById(
    "web-messenger-container"
  ) as HTMLIFrameElement;
  if (iframe) {
    const iframeDocument =
      iframe.contentDocument ??
      (iframe.contentWindow ? iframe.contentWindow.document : null);
    return iframeDocument?.querySelector(selector) as HTMLElement;
  }
  return null;
};

export const removeSunCoLogo = () => {
  const sunCoLogo = getIframeElementFromSelector(".logo");
  if (sunCoLogo) {
    sunCoLogo.style.display = "none";
  }
};

export const hideInputField = () => {
  const messageInputField = getIframeElementFromSelector("#footer");
  if (messageInputField) {
    messageInputField.style.display = "none";
  }
};

export const showInputField = () => {
  const messageInputField = getIframeElementFromSelector("#footer");
  if (messageInputField) {
    messageInputField.style.display = "flex";
  }
};

export const addHotjarToIframeAttribute = () => {
  const iframe = document.getElementById(
    "web-messenger-container"
  ) as HTMLIFrameElement;
  if (iframe) {
    iframe.setAttribute("data-hj-allow-iframe", "true");
  }
};

const shouldDisplayLanguageTopBanner = () => {
  const chatAvailableLanguages = getSettingHelpCenterChatAvailableLocales().map(
    (locale) => locale.language
  );
  return !chatAvailableLanguages.includes(browserLevelLanguage());
};

export const displayTopBanner = (strictLocalize: StrictLocalizeFunction) => {
  const topBanner = getIframeElementFromSelector(".intro-pane");
  if (topBanner && shouldDisplayLanguageTopBanner()) {
    topBanner.style.backgroundColor = Core.surface.info;
    topBanner.style.padding = getSpacing("2x");
    topBanner.textContent = strictLocalize({
      defaultMessage: "Chat support is currently available in English",
      description: {
        text: "A disclaimer message to inform users that chat support is only available in English",
      },
    });
  }
};

export const hideTopBanner = () => {
  const topBanner = getIframeElementFromSelector(".intro-pane");
  if (topBanner) {
    topBanner.style.display = "none";
  }
};
